'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function BlockEnable(props) {
    return React.createElement(
        IconBase,
        _extends({ viewBox: '0 0 16 16' }, props),
        React.createElement(
            'g',
            { stroke: 'none', 'stroke-width': '1', fillRule: 'evenodd' },
            React.createElement(
                'g',
                { transform: 'translate(-53.000000, -260.000000)' },
                React.createElement(
                    'g',
                    { transform: 'translate(53.000000, 134.000000)' },
                    React.createElement(
                        'g',
                        { transform: 'translate(0.000000, 126.000000)' },
                        React.createElement(
                            'g',
                            { transform: 'translate(1.000000, 1.000000)' },
                            React.createElement('path', { d: 'M3.11625574,7.818706 L1,7.818706 L1,7.818706 C0.44771525,7.818706 -6.76353751e-17,8.26642125 0,8.818706 L0,8.818706 L4.4408921e-16,11.9482017 C5.11724585e-16,12.5004865 0.44771525,12.9482017 1,12.9482017 L4,12.9482017 C4.14519117,12.9482017 4.28315532,12.9172592 4.40765783,12.8616087 C3.52923279,11.8180417 3,10.4708253 3,9 C3,8.59564614 3.03999887,8.20063452 3.11625574,7.818706 Z M5,4.52778699 L5,1.63741201 C5,1.08512726 4.55228475,0.637412008 4,0.637412008 L4,0.637412008 L1,0.637412008 L1,0.637412008 C0.44771525,0.637412008 -6.76353751e-17,1.08512726 0,1.63741201 L0,1.63741201 L4.4408921e-16,4.76690772 C5.11724585e-16,5.31919247 0.44771525,5.76690772 1,5.76690772 L1,5.76690772 L3.94470457,5.76690772 C4.23929586,5.30723698 4.59486606,4.89039168 5,4.52778699 Z M12.2694822,3.96821153 L12.3742108,3.863483 C12.7647351,3.4729587 12.7647351,2.83979373 12.3742108,2.44926943 L10.2528904,0.327949091 L10.2528904,0.327949091 C9.86236614,-0.062575201 9.22920116,-0.062575201 8.83867687,0.327949091 L8.83867687,0.327949091 L6.62578923,2.54083673 C6.34108728,2.82553868 6.26394015,3.23919867 6.39434785,3.59378944 C7.18237597,3.21328358 8.06628046,3 9,3 C10.2060188,3 11.328931,3.35582194 12.2694822,3.96821153 Z' }),
                            React.createElement('path', { d: 'M9,14 C6.23857625,14 4,11.7614237 4,9 C4,6.23857625 6.23857625,4 9,4 C11.7614237,4 14,6.23857625 14,9 C14,11.7614237 11.7614237,14 9,14 Z M8.3851909,9.6787709 L7.32453073,8.61811072 C7.12926858,8.42284858 6.79838835,8.43714632 6.58548905,8.65004562 C6.37258975,8.86294492 6.35829201,9.19382515 6.55355415,9.3890873 L7.96776772,10.8033009 C8.06539879,10.9009319 8.19693438,10.946173 8.33067462,10.940394 C8.46441486,10.9346149 8.60035974,10.8778156 8.70680939,10.771366 L11.4713667,8.00680863 C11.684266,7.79390933 11.6985638,7.4630291 11.5033016,7.26776695 C11.3080395,7.07250481 10.9771592,7.08680255 10.7642599,7.29970185 L8.3851909,9.6787709 Z' })
                        )
                    )
                )
            )
        )
    );
}
BlockEnable.displayName = 'BlockEnable';

module.exports = BlockEnable;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/blockEnable.js
// module id = 154
// module chunks = 0